import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'tableResponsiveWidth'
})
export class TableResponsiveWidthPipe implements PipeTransform {
  public transform(
    showSelectedItemInfo: boolean,
    breakPointScreen: 0 | 1 | 2 | 3 | 4 | 5,
  ): string {
    if (!showSelectedItemInfo) {
      return '100%';
    }
    if (breakPointScreen === 5) {
      return '0%';
    }
    if (breakPointScreen === 1) {
      return '0%';
    }
    if (breakPointScreen === 2) {
      return 'calc(70% - 10px)';
    }
    return '70%';
  }
}
